import { defineStore } from 'pinia';

export const useApiEnvStore = defineStore('apienv', () => {
	const devApi = false;
	let apiBaseUrl = 'http://127.0.0.1:5001/mintech-ecosystem/us-central1';

	if (!devApi) {
		apiBaseUrl = 'https://us-central1-mintech-ecosystem.cloudfunctions.net';
	}

	return { apiBaseUrl };
});
